import React, { memo, useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { HStack, Spinner } from 'native-base';
import { AllSettled, Button, Iconography, getAdditionalProperties, logUserEvent } from 'fmc-digital-common';
import { useLipStore } from '../../../loaninprogress';
import { useUploadFilesMutation } from '../../../loaninprogress/hooks/DocUpload';
import { Platform } from 'react-native';
import { get } from 'lodash';
const DocUploadFooter = ({
  taskName,
  onHideFileOption
}) => {
  const client = useQueryClient();
  const {
    setShowDocUploadModal,
    setShowDocUploadModalWeb,
    files: fileData,
    clearSelectedFiles: clearFiles,
    isDocUploading,
    trackingItemName,
    setDocUploading,
    setErrorMessages,
    clearErrorMessages,
    errorMessages,
    setToastMessageProps,
    setUploadedFiles
  } = useLipStore(state => state);
  //@ts-ignore
  const loanNumber = getAdditionalProperties('amplify')?.loanNumber;
  const mutation = useUploadFilesMutation();
  const onHandleUploadFiles = useCallback(async () => {
    logUserEvent({
      action: 'UploadClicked',
      type: 'LIPDocUploadPopUp',
      description: 'Task Section Doc Upload Task ' + taskName
    });
    if (fileData && fileData.length) {
      setDocUploading(true);
      const uploadFilesMutation = fileData.map(file => mutation.mutateAsync({
        file,
        documentName: trackingItemName
      }));
      let uploadedFiles = [];
      try {
        const response = await AllSettled(uploadFilesMutation);
        if (Platform.OS === 'web') {
          uploadedFiles = fileData;
          response?.map((item, index) => {
            if (item.status === 'fulfilled' && get(item, ['value', 'fileUploadStatus'], false)) {
              uploadedFiles[index].isSuccess = true;
            } else {
              uploadedFiles[index].isSuccess = false;
            }
          });
        } else {
          response?.map((item, index) => {
            if (item.status === 'fulfilled' && get(item, ['value', 'fileUploadStatus'], false)) {
              const dataa = {
                ...fileData[index],
                isSuccess: true
              };
              uploadedFiles.push(dataa);
            } else {
              const dataa = {
                ...fileData[index],
                isSuccess: false
              };
              uploadedFiles.push(dataa);
            }
          });
        }
        logUserEvent({
          action: 'SuccessToastDisplayed',
          type: 'LIPDocUploadSuccessToast',
          description: 'Task Section Doc Upload Task ' + taskName
        });
        await client.invalidateQueries({
          queryKey: ['tracking-items', loanNumber]
        });
      } catch (e) {
        logUserEvent({
          action: 'FailureToastDisplayed',
          type: 'LIPDocUploadFailureToast',
          description: 'Task Section Doc Upload Task ' + taskName
        });
      } finally {
        setShowDocUploadModal(false);
        setShowDocUploadModalWeb(false);
        clearFiles();
        setUploadedFiles(uploadedFiles);
        const successfullUploads = uploadedFiles?.filter(item => item.isSuccess);
        const failedUploads = uploadedFiles?.some(item => !item.isSuccess);
        if (successfullUploads?.length > 0) {
          setToastMessageProps({
            isShowToastMessage: true,
            message: successfullUploads?.length > 1 ? 'Files uploaded successfully' : 'File uploaded successfully',
            buttonText: 'Upload More',
            type: 'docUploadMessage',
            trackingItemName: trackingItemName,
            toastType: 'SUCCESS'
          });
        }
        if (failedUploads) {
          setToastMessageProps({
            isShowToastMessage: true,
            message: 'Something went wrong on our end uploading your files:',
            buttonText: 'Try Again',
            type: 'docUploadMessage',
            trackingItemName: trackingItemName,
            toastType: 'ERROR'
          });
        }
        setDocUploading(false);
        clearErrorMessages();
      }
    } else {
      if (errorMessages && errorMessages.findIndex(err => err.errorType === 'NoFile') === -1) {
        setErrorMessages([{
          errorType: 'NoFile'
        }]);
      }
    }
  }, [taskName, fileData, setDocUploading, mutation, trackingItemName, setShowDocUploadModal, setShowDocUploadModalWeb, clearFiles, client, loanNumber, setErrorMessages, clearErrorMessages, errorMessages, setToastMessageProps, setUploadedFiles]);
  return /*#__PURE__*/React.createElement(HStack, {
    justifyContent: 'flex-end',
    space: '2',
    paddingRight: '0'
  }, /*#__PURE__*/React.createElement(Button, {
    variant: 'outline',
    onPress: () => {
      setShowDocUploadModal(false);
      setShowDocUploadModalWeb(false);
      clearFiles();
      clearErrorMessages();
      if (onHideFileOption) onHideFileOption();
      logUserEvent({
        action: 'CancelClicked',
        type: 'LIPDocUploadPopUp',
        description: 'Task Section Doc Upload Task ' + taskName
      });
    },
    disabled: isDocUploading,
    accessibilityLabel: "Cancel",
    accessibilityRole: "button"
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    leftIcon: !isDocUploading ? /*#__PURE__*/React.createElement(Iconography, {
      name: "file-upload",
      size: 16,
      color: "white.500"
    }) : undefined,
    paddingLeft: '4',
    paddingRight: '4',
    onPress: onHandleUploadFiles,
    disabled: isDocUploading,
    accessibilityLabel: "Document Upload",
    accessibilityRole: "button"
  }, isDocUploading ? /*#__PURE__*/React.createElement(Spinner, {
    color: "white.500"
  }) : 'Upload'));
};
export default /*#__PURE__*/memo(DocUploadFooter);
//# sourceMappingURL=index.js.map